// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"68e0ed27","239":"d2961449","455":"9989f9d5","977":"8b74bd2d"}[chunkId] + ".chunk.js";
};